import { defineLocale } from "../../registry";

const shell = defineLocale({
  ru: {
    "shell.title": "Picks",
    "shell.noPermission.title": "Раздел недоступен для вашей роли",
    "shell.loading": "Проверка прав доступа…",
    "shell.page.catalog": "Catalog",
    "shell.page.create": "New pick",
    "shell.page.editor": "Pick",
    "shell.page.partners": "Partners",
    "shell.page.categories": "Categories & Icons",
  },
  en: {
    "shell.title": "Picks",
    "shell.noPermission.title": "This section is not available for your role",
    "shell.loading": "Checking access…",
    "shell.page.catalog": "Catalog",
    "shell.page.create": "New pick",
    "shell.page.editor": "Pick",
    "shell.page.partners": "Partners",
    "shell.page.categories": "Categories & Icons",
  },
});

export default shell;
